var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(require('../../assets/images/404.png')),expression:"require('../../assets/images/404.png')",arg:"background-image"}],staticClass:"errorimg"}),_vm._v(" "),_c('div',{staticClass:"errorname"},[_vm._v("页面找不到了哦～")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8daa820e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/underfind/index.vue
// module id = null
// module chunks = 